module.exports = __webpack_public_path__ + "static/img/title-3.9d0821e3.svg";